import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
// import * as xlsx from 'xlsx';
import { FnUtilService } from '../../../services/fn-util.service';
import { FnTableExportColumn } from './fn-grid-export.model';
import { FnCsvService } from './../../../services/fn-csv.service';

@Component({
	selector: 'fn-grid-export',
	templateUrl: 'fn-grid-export.component.html',
	styleUrls: ['fn-grid-export.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnGridExportComponent implements OnInit {
	@Input() dataArray: Array<object> = [];
	@Input() columArray: Array<FnTableExportColumn> = [];
	@Input() reportName = 'report';
	constructor(private fnUtil: FnUtilService, private fnCsvSvcs: FnCsvService) {}
	private csvHeader: Array<string> = [];
	private csvSortData: Array<string> = [];
	ngOnInit(): void {
		for (let i = 0; i < this.columArray.length; i++) {
			const col = this.columArray[i];
			this.csvHeader.push(col.header);
			this.csvSortData.push(col.dataKey);
		}
	}
	createPdf() {
		const doc = new jsPDF('portrait', 'mm', 'a3');
		doc.setFontSize(18);
		doc.text(this.reportName, 10, 10);
		doc.setFontSize(11);
		doc.setTextColor(100);
		doc.setPage(0);
		(doc as any).autoTable({
			body: this.dataArray,
			columns: this.columArray,
 			startY: 20,
		       showHead: 'firstPage'
		});
		this.addFooters(doc);
		doc.save(this.reportName + '.pdf');
	}

	  addFooters(doc:any) {
		const pageCount = doc.internal.getNumberOfPages();
		doc.setFont('helvetica', 'italic');
		doc.setFontSize(8);
		for (let i = 1; i <= pageCount; i++) {
		  doc.setPage(i);
		  doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, 287, {
			align: 'center'
		  });
		}
	  }

	createXLSX() {
		// const wb = xlsx.utils.table_to_book(document.getElementById('tableData'));
		// xlsx.writeFile(wb, this.reportName + '.xlsx');
	}
	
	createCsv() {
		this.fnCsvSvcs.generateCsv(this.dataArray, {
			headers: this.csvHeader,
			sortByKeys: this.csvSortData,
			filename: this.reportName,
		});
	}
}
